import React, { useEffect, useRef } from 'react';
import { useNpCoordination } from '../context/NpCoordinationContext';

import { Pagination } from '@td/ui';
const TablePagination = () => {
  const { activePage, totalItemsCount, setActivePage, filters, debouncedLoadItems } = useNpCoordination();

  const lastActivePageRef = useRef();
  useEffect(() => {
    if (lastActivePageRef.current === undefined || lastActivePageRef.current === activePage) {
      lastActivePageRef.current = activePage;
      return;
    }

    lastActivePageRef.current = activePage;
    debouncedLoadItems(filters, activePage);
  }, [activePage]);


  return (
    <div className="pagination">
      <Pagination
        activePage={activePage}
        totalItemsCount={totalItemsCount}
        itemsCountPerPage={15}
        onChange={setActivePage}
      />
    </div>
  );
};

export default TablePagination;
